/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import axios from 'axios'

import { logout } from '../actions/auth.action'
import { isEmpty, trimmer } from '../helpers/utils'
import STORE from './../store'
import { API } from './api'
import localStorageService from './localStorageService'

let axiosInstance = null
const configurationSetting = (store) => {
  //   axios.defaults.baseURL = baseRoute
  //   axios.defaults.timeout = timeout
  axiosInstance = axios.create()
  setupInterceptors(store)
}

const setAxiosBase = (config) => {
  if (axiosInstance === null) {
    axiosInstance = axios.create()
  }
  if (config.baseURL) {
    axiosInstance.defaults.baseURL = config.baseURL
    axiosInstance.defaults.withCredentials = true
  }
  if (config['X-CW-Tenant-Id']) {
    axiosInstance.defaults.headers.common['X-CW-Tenant-Id'] = config['X-CW-Tenant-Id']
  }
  if (config.Authorization) {
    axiosInstance.defaults.headers.common['Authorization'] = config.Authorization
  }
  if (config['realm-name']) {
    axiosInstance.defaults.headers.common['realm-name'] = config['realm-name']
  }
}

const updateTimeout = (timeout) => {
  axios.defaults.timeout = timeout
}

async function fetch(url, tokencConfig = {}) {
  const { headers, ...rest } = tokencConfig
  const baseConfig = {
    headers: {
      ...headers,
    },
    ...rest,
  }
  const response = await axiosInstance.get(url, baseConfig)
  if (response.status >= 200 && response.status < 300) {
    return { data: response.data, status: response.status }
  }
  const error = new Error(response.statusText)
  error.response = response
  throw error
}

async function post(url, data, tokencConfig = {}) {
  const { headers, ...rest } = tokencConfig
  // const baseConfig = {
  //   headers: {
  //     'Content-Type': 'application/json',
  //     ...headers,
  //   },
  //   ...rest,
  // }
  const isFormData = data instanceof FormData

  const baseConfig = {
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...headers,
    },
    ...rest,
  }
  const response = await axiosInstance.post(url, trimmer(data), baseConfig)
  if (response.status >= 200 && response.status < 300) {
    return {
      data: response.data,
      status: response.status,
      headers: response.headers,
    }
  }
  const error = new Error(response.statusText)
  error.response = response
  throw error
}

async function put(url, data, tokencConfig = {}) {
  const { headers, ...rest } = tokencConfig
  // const baseConfig = {
  //   headers: {
  //     'Content-Type': 'application/json',
  //     ...headers,
  //   },
  //   ...rest,
  // }

  const isFormData = data instanceof FormData

  const baseConfig = {
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...headers,
    },
    ...rest,
  }
  const response = await axiosInstance.put(url, trimmer(data), baseConfig)
  if (response.status >= 200 && response.status < 300) {
    return { data: response.data, status: response.status }
  }
  const error = new Error(response.statusText)
  error.response = response
  throw error
}

async function remove(url, tokencConfig = {}, data = {}) {
  const { headers, ...rest } = tokencConfig
  const baseConfig = {
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    ...rest,
  }
  if (!isEmpty(data)) {
    baseConfig.data = trimmer(data)
  }
  const response = await axiosInstance.delete(url, baseConfig)
  if (response.status >= 200 && response.status < 300) {
    return { status: response.status }
  }
  const error = new Error(response.statusText)
  error.response = response
  throw error
}

async function patch(url, data, tokencConfig = {}) {
  const { headers, ...rest } = tokencConfig
  // const baseConfig = {
  //   headers: {
  //     'Content-Type': 'application/json',
  //     ...headers,
  //   },
  //   ...rest,
  // }

  const isFormData = data instanceof FormData

  const baseConfig = {
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...headers,
    },
    ...rest,
  }
  const response = await axiosInstance.patch(url, trimmer(data), baseConfig)
  if (response.status >= 200 && response.status < 300) {
    return {
      data: response.data,
      status: response.status,
      headers: response.headers,
    }
  }
  const error = new Error(response.statusText)
  error.response = response

  throw err
}

const setupInterceptors = () => {
  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    function (error) {
      const originalRequest = error.config
      // const tenantId = originalRequest.headers['X-CW-Tenant-Id']
      // if (tenantId === 'master') {
      //   handleAdminError(error, axiosInstance, store)
      // }
      if (error.response && error.response.status) {
        if (
          error.config.url !== API.AUTH.LOGIN &&
          error.config.url !== API.AUTH.REGISTER &&
          error.config.url !== API.AUTH.FORGOTPASSWORD
        ) {
          if (error.response.status === 403 && originalRequest.url === API.AUTH.REFRESH) {
            const params = localStorageService.getDistrictSchool()
            STORE.dispatch(logout(params))
            return Promise.reject(error)
          }
          if (
            error.response.status === 403 &&
            !originalRequest._retry &&
            !(error.response.data && error.response.data.code)
          ) {
            originalRequest._retry = true
            // const { refreshToken, accountId, userName } = localStorageService.getAccessToken()
            // if (!(refreshToken && accountId)) {
            const params = localStorageService.getDistrictSchool()
            STORE.dispatch(logout(params))
            return Promise.reject(error)
          } else {
            return Promise.reject(error)
          }
        } else {
          return Promise.reject(error)
        }
      } else {
        return Promise.reject(error)
      }
    }
  )
}

export { fetch, patch, post, put, remove, setAxiosBase, updateTimeout }

export default configurationSetting
